let page_schema = {
	"tiers": [
		{
			"name": "Nucleic Acid Type",
			"type": "checkbox",
			"id": "nucleic-acid-types",
			"class_name": "tags",
			"child_name": "nucleic-acid-type",
			"options": [
				{
					"name": "Double Stranded DNA",
					"id": "double-stranded-dna"
				},
				{
					"name": "Single Stranded DNA",
					"id": "single-stranded-dna"
				},
				{
					"name": "RNA",
					"id": "rna"
				},
				{
					"name": "Oligo",
					"id": "oligo"
				},
			]
		},
		{
			"name": "Sample Type",
			"type": "checkbox",
			"id": "sample-types",
			"class_name": "tags",
			"child_name": "sample-type",
			"options": [
				{
					"name": "Agarose Gel",
					"id": "agarose-gel"
				},
				{
					"name": "Aqueous Phase",
					"id": "aqueous-phase"
				},
				{
					"name": "Chemical Synthesis",
					"id": "chemical-synthesis"
				},
				{
					"name": "Chromatin Immunoprecipitation",
					"id": "chromatin-immunoprecipitation"
				},
				{
					"name": "Crude Extraction",
					"id": "crude-extraction"
				},
				{
					"name": "Dye Terminator Sequencing Reaction",
					"id": "dye-terminator-sequencing-reaction"
				},
				{
					"name": "Enzymatic Reaction (PCR, Digestions, Ligations, etc.)",
					"id": "enzymatic-reaction"
				},
				{
					"name": "In vitro Labeling",
					"id": "in-vitro-labeling"
				},
				{
					"name": "NGS Library Preparation",
					"id": "ngs-library-preparation"
				},
				{
					"name": "Purified Nucleic Acid",
					"id": "purified-nucleic-acid"
				}
			]
		},
		{
			"name": "Binding Capacity",
			"type": "checkbox",
			"id": "binding-capacitys",
			"class_name": "tags",
			"child_name": "binding-capacity",
			"options": [
				{
					"name": "≤ 3 µg",
					"id": "le-3-microg"
				},
				{
					"name": "≤ 5 µg",
					"id": "le-5-microg"
				},
				{
					"name": "≤ 10 µg",
					"id": "le-10-microg"
				},
				{
					"name": "≤ 25 µg",
					"id": "le-25-microg"
				},
				{
					"name": "≤ 100 µg",
					"id": "le-100-microg"
				},
				{
					"name": "≤ 500 µg",
					"id": "le-500-microg"
				},
			]
		},
		{
			"name": "Nucleic Acid Size",
			"type": "checkbox",
			"id": "nucleic-acid-sizes",
			"class_name": "tags",
			"child_name": "nucleic-acid-size",
			"options": [
				{
					"name": "17 - 200 nt",
					"id": "17-200-nt"
				},
				{
					"name": "50 bp - 10 kb",
					"id": "50-bp-10-kb"
				},
				// {
				// 	"name": "50 bp - 23 kb",
				// 	"id": "50-bp-23-kb"
				// },
				{
					"name": "10 kb - 200 kb",
					"id": "10-kb-200-kb"
				},
				// {
				// 	"name": "50 bp - 200 kb",
				// 	"id": "50-bp-200-kb"
				// },
			]
		},
		{
			"name": "Features",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "Size Selection",
					"id": "size-selection"
				},
				{
					"name": "Concentration",
					"id": "concentration"
				},
				{
					"name": "PCR Inhibitor Removal",
					"id": "pcr-inhibitor-removal"
				},
				{
					"name": "High-Throughput",
					"id": "high-throughput"
				},
				// {
				// 	"name": "Magnetic Beads (Automatable)",
				// 	"id": "magnetic-beads-(automatable)"
				// },
			]
		},
		{
			"name": "Format",
			"type": "checkbox",
			"id": "formats",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "Spin-Column",
					"id": "spin-column"
				},
				{
					"name": "96-Well",
					"id": "96-well"
				},
				{
					"name": "Magnetic Beads (Automatable)",
					"id": "magnetic-beads"
				},
			]
		},
        {//FOR ALL CLEANUP FILTER PAGES HIDE THIS DROPDOWN
            "name": "PreFilters",
            "type": "checkbox",
            "id": "prefilters",
            "class_name": "tags",
            "child_name": "prefilter",
            "options": [
                {
                    "name": "DNA Clean Up Kits",
                    "id": "dna-clean-up"
                },
                {
                    "name": "PCR Purification Kits",
                    "id": "pcr-purification-kits"
                },
				{
                    "name": "Genomic DNA Clean Concentrator",
                    "id": "genomic-dna-clean-concentrator"
                }
            ]
        }
	],
	"filters": [],
	"products": {
		"DNA Clean & Concentrator-5": {
			"title": "DNA Clean & Concentrator-5",
			"catalogNumbers": "D4003, D4003T, D4004, D4013, D4014",
			"description": "Purify up to 5 µg of highly concentrated ultra-pure DNA from PCR, enzymatic reactions, and other sources in 2 minutes.",
			"handle": "/products/dna-clean-concentrator-5",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4004.webp",
			"generalIndex": "1",
			"id": "dna-clean-concentrator-5",
			"tags": [
				"double-stranded-dna",
				"single-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"ngs-library-preparation",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"le-5-microg",
				"50-bp-10-kb",
				"spin-column",
				"pcr-purification-kits",
				"dna-clean-up"
			],
			filters: []
		},
		"DNA Clean & Concentrator-25": {
			"title": "DNA Clean & Concentrator-25",
			"catalogNumbers": "D4005, D4006, D4033, D4034",
			"description": "Purify up to 25 µg of highly concentrated ultra-pure DNA from PCR, enzymatic reactions, and other sources in 2 minutes.",
			"handle": "/collections/dcc-dna-clean-up/products/dna-clean-concentrator-25",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4005.webp",
			"generalIndex": "2",
			"id": "dna-clean-concentrator-25",
			"tags": [
				"double-stranded-dna",
				"single-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"ngs-library-preparation",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"le-25-microg",
				"50-bp-10-kb",
				"pcr-purification-kits",
				"spin-column",
				"dna-clean-up"
			],
			filters: []
		},
		"DNA Clean & Concentrator-100": {
			"title": "DNA Clean & Concentrator-100",
			"catalogNumbers": "D4029, D4030",
			"description": "Quickly purify up to 100 µg of highly concentrated ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
			"handle": "/products/dna-clean-concentrator-100",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4029_DNA-Clean-and-Concentrator-100-Kit.jpg?v=1628532369&width=600",
			"generalIndex": "3",
			"id": "dna-clean-concentrator-100",
			"tags": [
				"double-stranded-dna",
				"single-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"ngs-library-preparation",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"pcr-purification-kits",
				"le-100-microg",
				"50-bp-10-kb",
				"spin-column",
				"dna-clean-up"
			],
			filters: []
		},
		"DNA Clean & Concentrator-500": {
			"title": "DNA Clean & Concentrator-500",
			"catalogNumbers": "D4031, D4032",
			"description": "Quickly purify up to 500 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
			"handle": "/products/dna-clean-concentrator-500",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4031-DNA-Clean-_-Concentrator--500.jpg?v=1628532352&width=600",
			"generalIndex": "4",
			"id": "dna-clean-concentrator-500",
			"tags": [
				"double-stranded-dna",
				"single-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"ngs-library-preparation",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"le-500-microg",
				"50-bp-10-kb",
				"spin-column",
				"pcr-purification-kits",
				"dna-clean-up"
			],
			filters: []
		},
		"DNA Clean & Concentrator MagBead Kit": {
			"title": "DNA Clean & Concentrator MagBead Kit",
			"catalogNumbers": "D4012",
			"description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
			"handle": "/products/dna-clean-concentrator-magbead-kit",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4012.webp",
			"generalIndex": "7",
			"id": "dna-clean-concentrator-magbead-kit",
			"tags": [
				"double-stranded-dna",
				// "single-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"ngs-library-preparation",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"magnetic-beads-(automatable)",
				"le-5-microg",
				"50-bp-200-kb",
				"magnetic-beads",
				"10-kb-200-kb",
				"50-bp-10-kb",
				"high-throughput",
				"pcr-purification-kits",
				"dna-clean-up",
				"genomic-dna-clean-concentrator"
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 2
				// }
			]
		},
		"ZR-96 DNA Clean-Up Kit (Shallow Well)": {
			"title": "ZR-96 DNA Clean-Up Kit (Shallow Well)",
			"catalogNumbers": "D4017, D4018",
			"description": "High-throughput purification of up to 5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources using a low-profile spin-plate.",
			"handle": "/collections/dcc-dna-clean-up/products/zr-96-dna-clean-up-kit",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D4017_ZR-96-DNA-Clean-up-Kit_1200x.jpg",
			"generalIndex": "5",
			"id": "zr-96-dna-clean-up-kit",
			"tags": [
				"double-stranded-dna",
				"single-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"high-throughput",
				"le-5-microg",
				"50-bp-10-kb",
				"96-well",
				"pcr-purification-kits",
				"dna-clean-up",
				"ngs-library-preparation"
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 0
				// }
			]
		},
		"ZR-96 DNA Clean & Concentrator-5": {
			"title": "ZR-96 DNA Clean & Concentrator-5 Kit",
			"catalogNumbers": "D4023, D4024",
			"description": "High-throughput purification of up to 5 µg of highly concentrated ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
			"handle": "/collections/dcc-dna-clean-up/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4023.webp",
			"generalIndex": "6",
			"id": "zr-96-dna-clean-amp-concentrator-5-deep-well",
			"tags": [
				"double-stranded-dna",
				"single-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"high-throughput",
				"le-5-microg",
				"50-bp-10-kb",
				"96-well",
				"pcr-purification-kits",
				"dna-clean-up",
				"ngs-library-preparation"
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 1
				// }
			]
		},
		"Genomic DNA Clean & Concentrator-10": {
			"title": "Genomic DNA Clean & Concentrator-10",
			"catalogNumbers": "D4010, D4011",
			"description": "Purify up to 10 µg of ultra-pure high molecular weight DNA from any enzymatic reaction or impure preparation using a simple spin-column protocol.",
			"handle": "/collections/genomic-dna-clean-concentrator-gdcc/products/genomic-dna-clean-concentrator-10",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4011_b.webp",
			"generalIndex": "12",
			"id": "genomic-dna-clean-concentrator-10",
			"tags": [
				"double-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"le-10-microg",
				"10-kb-200-kb",
				"spin-column",
				"dna-clean-up",
				"genomic-dna-clean-concentrator"
			],
			filters: []
		},
		"Genomic DNA Clean & Concentrator-25": {
			"title": "Genomic DNA Clean & Concentrator-25",
			"catalogNumbers": "D4064, D4065",
			"description": "Purify up to 25 µg of ultra-pure high molecular weight DNA from any enzymatic reaction or impure preparation using a simple spin-column protocol.",
			"handle": "/collections/genomic-dna-clean-concentrator-gdcc/products/genomic-dna-clean-concentrator-25",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4064.webp",
			"generalIndex": "13",
			"id": "genomic-dna-clean-concentrator-25",
			"tags": [
				"double-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"le-25-microg",
				"10-kb-200-kb",
				"spin-column",
				"dna-clean-up",
				"genomic-dna-clean-concentrator"
			],
			filters: []
		},
		"ZR-96 Genomic DNA Clean & Concentrator-5 Kit": {
			"title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
			"catalogNumbers": "D4066, D4067",
			"description": "High-throughput purification of up to 5 µg of ultra-pure high molecular weight DNA from any enzymatic reaction or impure preparation.",
			"handle": "/collections/genomic-dna-clean-concentrator-gdcc/products/zr-96-genomic-dna-clean-concentrator-5-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg?v=1628532355&width=600",
			"generalIndex": "14",
			"id": "zr-96-genomic-dna-clean-concentrator-5-kit",
			"tags": [
				"double-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"aqueous-phase",
				"crude-extraction",
				"chemical-synthesis",
				"concentration",
				"high-throughput",
				"le-5-microg",
				"10-kb-200-kb",
				"96-well",
				"dna-clean-up",
				"genomic-dna-clean-concentrator"
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 5
				// }
			]
		},
		"Oligo Clean & Concentrator": {
			"title": "Oligo Clean & Concentrator",
			"catalogNumbers": "D4060, D4061",
			"description": "Rapidly recover up to 10 µg of highly concentrated DNA or RNA oligos from labeling and other enzymatic reactions.",
			"handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4060.webp",
			"generalIndex": "15",
			"id": "oligo-clean-concentrator",
			"tags": [
				"rna",
				"oligo",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"aqueous-phase",
				"chemical-synthesis",
				"concentration",
				"le-10-microg",
				"17-200-nt",
				"spin-column",
			],
			filters: []
		},
		"ZR-96 Oligo Clean & Concentrator": {
			"title": "ZR-96 Oligo Clean & Concentrator Kit",
			"catalogNumbers": "D4062, D4063",
			"description": "High-throughput purification of up to 10 µg of highly concentrated DNA or RNA oligos from labeling and other enzymatic reactions.",
			"handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator-zr96",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4062_ZR-96-Oligo-Clean-Concentrator.png?v=1628532356&width=600",
			"generalIndex": "16",
			"id": "oligo-clean-concentrator-zr96",
			"tags": [
				"rna",
				"oligo",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"aqueous-phase",
				"chemical-synthesis",
				"concentration",
				"high-throughput",
				"le-10-microg",
				"17-200-nt",
				"96-well",
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 6
				// }
			]
		},
		"ssDNA/RNA Clean & Concentrator": {
			"title": "ssDNA/RNA Clean & Concentrator",
			"catalogNumbers": "D7010, D7011",
			"description": "Easily purify up to 10 µg of highly concentrated single stranded DNA or RNA from samples containing double stranded DNA.",
			"handle": "/products/ssdna-rna-clean-concentrator",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit_15e63804-98d4-4820-973a-01c4d951f139.jpg?v=1628532354&width=600",
			"generalIndex": "22",
			"id": "ssdna-rna-clean-concentrator",
			"tags": [
				"single-stranded-dna",
				"rna",
				"dna-clean-up",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"in-vitro-labeling",
				"aqueous-phase",
				"chemical-synthesis",
				"concentration",
				"le-10-microg",
				"17-200-nt",
				"spin-column",
			],
			filters: []
		},
		"ZR DNA Sequencing Clean-Up Kit": {
			"title": "ZR DNA Sequencing Clean-Up Kit",
			"catalogNumbers": "D4050, D4051",
			"description": "Efficiently clean up dye terminator sequencing reactions prior to Sanger Sequencing in just 2 minutes.",
			"handle": "/collections/dna-sequencing-clean-up-kits/products/zr-dna-sequencing-clean-up-kit",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4050.webp",
			"generalIndex": "23",
			"id": "zr-dna-sequencing-clean-up-kit",
			"tags": [
				"double-stranded-dna",
				"dye-terminator-sequencing-reaction",
				"le-5-microg",
				"50-bp-10-kb",
				"spin-column",
			],
			filters: []
		},
		"ZR-96 DNA Sequencing Clean-up Kit": {
			"title": "ZR-96 DNA Sequencing Clean-up Kit",
			"catalogNumbers": "D4052, D4053",
			"description": "High-throughput and rapid clean up of dye terminator sequencing reactions prior to Sanger Sequencing.",
			"handle": "/collections/dna-sequencing-clean-up-kits/products/zr-96-dna-sequencing-clean-up-kit",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4052.webp",
			"generalIndex": "24",
			"id": "zr-96-dna-sequencing-clean-up-kit",
			"tags": [
				"double-stranded-dna",
				"dye-terminator-sequencing-reaction",
				"high-throughput",
				"le-5-microg",
				"50-bp-10-kb",
				"96-well",
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 8
				// }
			]
		},
		"Select-a-Size DNA Clean & Concentrator Kit": {
			"title": "Select-a-Size DNA Clean & Concentrator Kit",
			"catalogNumbers": "D4080",
			"description": "Recover a specific size range of ultra-pure DNA fragments from library preps, PCR, and ligations using a quick spin-column protocol.",
			"handle": "/collections/select-a-size-dna-clean-concentrator-kits/products/select-a-size-dna-clean-concentrator-kit",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4080.webp",
			"generalIndex": "17",
			"id": "select-a-size-dna-clean-concentrator-kit",
			"tags": [
				"double-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"ngs-library-preparation",
				"chemical-synthesis",
				"size-selection",
				"concentration",
				"50-bp-10-kb",
				"spin-column",
				// "le-5-microg",
				"dna-clean-up",
				"le-3-microg"
			],
			filters: []
		},
		"Select-a-Size DNA Clean & Concentrator MagBead Kit": {
			"title": "Select-a-Size DNA Clean & Concentrator MagBead Kit",
			"catalogNumbers": "D4084, D4085",
			"description": "Recover a specific size range of ultra-pure DNA fragments from library preps, PCR, and ligations using magnetic beads.",
			"handle": "/collections/select-a-size-dna-clean-concentrator-kits/products/select-a-size-dna-clean-concentrator-magbead-kit",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4084.webp",
			"generalIndex": "18",
			"id": "select-a-size-dna-clean-concentrator-magbead-kit",
			"tags": [
				"double-stranded-dna",
				"enzymatic-reaction",
				"purified-nucleic-acid",
				"ngs-library-preparation",
				"chemical-synthesis",
				"size-selection",
				"concentration",
				"magnetic-beads-(automatable)",
				"10-kb-200-kb",
				// "50-bp-10-kb",
				"magnetic-beads",
				"le-10-microg",
				"high-throughput",
				"dna-clean-up",
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 10
				// }
			]
		},
		"Zymoclean Gel DNA Recovery Kit": {
			"title": "Zymoclean Gel DNA Recovery Kit",
			"catalogNumbers": "D4001, D4001T, D4002, D4007, D4008",
			"description": "Simple and quick isolation of highly concentrated ultra-pure DNA from TAE/TBE buffered agarose gels.",
			"handle": "/collections/zymoclean-gel-dna-recovery-kits/products/zymoclean-gel-dna-recovery-kit",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4001.webp",
			"generalIndex": "8",
			"id": "zymoclean-gel-dna-recovery-kit",
			"tags": [
				"double-stranded-dna",
				"agarose-gel",
				"le-5-microg",
				"50-bp-10-kb",
				"spin-column",
				"size-selection",
			],
			filters: []
		},
		"Zymoclean Large Fragment DNA Recovery": {
			"title": "Zymoclean Large Fragment DNA Recovery",
			"catalogNumbers": "D4045, D4046",
			"description": "Simple and quick isolation of ultra-pure high molecular weight DNA from TAE/TBE buffered agarose gels.",
			"handle": "/collections/zymoclean-gel-dna-recovery-kits/products/zymoclean-large-fragment-dna-recovery",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4045.webp",
			"generalIndex": "19",
			"id": "zymoclean-large-fragment-dna-recovery",
			"tags": [
				"double-stranded-dna",
				"agarose-gel",
				"le-10-microg",
				"10-kb-200-kb",
				"spin-column",
				"size-selection",
			],
			filters: []
		},
		"ZR-96 Zymoclean Gel DNA Recovery Kit": {
			"title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
			"catalogNumbers": "D4021, D4022",
			"description": "High-throughput purification of highly concentrated ultra-pure DNA from TAE/TBE buffered agarose gels.",
			"handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D4021.webp",
			"generalIndex": "9",
			"id": "zr-96-zymoclean-gel-dna-recovery-kit",
			"tags": [
				"double-stranded-dna",
				"agarose-gel",
				"high-throughput",
				"le-5-microg",
				"50-bp-10-kb",
				"96-well",
				"size-selection",
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 4
				// }
			]
		},
		"OneStep PCR Inhibitor Removal Kit": {
			"title": "<i>OneStep</i> PCR Inhibitor Removal Kit",
			"catalogNumbers": "D6031",
			"description": "Easily remove common PCR inhibitors from extracted DNA and RNA using a single step spin-column protocol.",
			"handle": "/products/onestep-pcr-inhibitor-removal-new-kit",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6031.webp",
			"generalIndex": "10",
			"id": "onestep-pcr-inhibitor-removal-new-kit",
			"tags": [
				"double-stranded-dna",
				"single-stranded-dna",
				"rna",
				"oligo",
				"purified-nucleic-acid",
				"crude-extraction",
				"pcr-inhibitor-removal",
				"50-bp-10-kb",
				"50-bp-23-kb",
				"10-kb-200-kb",
				"17-200-nt",
				"50-bp-200-kb",
				"spin-column",
			],
			filters: []
		},
		"OneStep-96 PCR Inhibitor Removal Kit": {
			"title": "<i>OneStep</i>-96 PCR Inhibitor Removal Kit",
			"catalogNumbers": "D6035",
			"description": "High-throughput removal of common PCR inhibitors from extracted DNA and RNA using a single step protocol.",
			"handle": "/products/onestep-pcr-inhibitor-removal-new-kit",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/dna/extraction/D6035.webp",
			"generalIndex": "11",
			"id": "onestep-pcr-inhibitor-removal-new-kit",
			"tags": [
				"double-stranded-dna",
				"single-stranded-dna",
				"rna",
				"oligo",
				"purified-nucleic-acid",
				"crude-extraction",
				"pcr-inhibitor-removal",
				"high-throughput",
				"50-bp-10-kb",
				"50-bp-23-kb",
				"10-kb-200-kb",
				"17-200-nt",
				"50-bp-200-kb",
				"96-well",
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 3
				// }
			]
		},
		"ChIP DNA Clean & Concentrator": {
			"title": "ChIP DNA Clean & Concentrator",
			"catalogNumbers": "D5201, D5205",
			"description": "Easily recover ultra-pure DNA from any step in a standard ChIP protocol using spin-column purification.",
			"handle": "/products/chip-dna-clean-concentrator",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5201_ChIP-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532405&width=600",
			"generalIndex": "20",
			"id": "chip-dna-clean-concentrator",
			"tags": [
				"double-stranded-dna",
				"chromatin-immunoprecipitation",
				"concentration",
				"le-5-microg",
				"50-bp-23-kb",
				"50-bp-10-kb",
				"spin-column",
				"dna-clean-up"
			],
			filters: []
		},
		"ZR-96 ChIP DNA Clean & Concentrator": {
			"title": "ZR-96 ChIP DNA Clean & Concentrator Kit",
			"catalogNumbers": "D5206, D5207",
			"description": "High-throughput recovery of ultra-pure DNA from any step in a standard ChIP protocol using rapid spin-column purification.",
			"handle": "/products/zr-96-chip-dna-clean-concentrator",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5206_ZR-96-ChIP-DNA-Clean-and-Concentrator-Kit.jpg?v=1628532406&width=600",
			"generalIndex": "21",
			"id": "zr-96-chip-dna-clean-concentrator",
			"tags": [
				"double-stranded-dna",
				"chromatin-immunoprecipitation",
				"concentration",
				"high-throughput",
				"le-5-microg",
				"50-bp-23-kb",
				"96-well",
				"50-bp-10-kb",
				"dna-clean-up"
			],
			"filters": [
				// {
				// 	"filter": "high-throughput",
				// 	"index": 9
				// }
			]
		},
	}
}